export const environment = {
  production: false,
  name: 'staging',
};
